import React from 'react';

const Layout = ({
  children,
  className
}) => {
  return /*#__PURE__*/React.createElement("section", {
    className: "section ".concat(className)
  }, /*#__PURE__*/React.createElement("article", {
    className: "section__content"
  }, children));
};

Layout.displayName = 'Layout';
Layout.defaultProps = {
  className: ''
};
export default Layout;